import { formatNumber } from '@angular/common';
import { Component, HostListener, Inject, LOCALE_ID, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { PlanModels } from 'src/app/models/plan_models';
import { DatosGeneralesModel } from 'src/app/models/datosGenenrales';
import { PlanesService } from 'src/app/services/Planes/planes.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pago-exitoso',
  standalone: false,
  templateUrl: './pago-exitoso.component.html',
  styleUrl: './pago-exitoso.component.scss'
})
export class PagoExitosoComponent implements OnInit, OnDestroy {
  checador: any;
  saliendo: boolean = false;
  sessionId: string = '';

  // @HostListener('document:mousemove', ['$event'])
  // onMouseMove(e: MouseEvent) {
  //   let posicionX, posicionY, nuevaPosicionY, nuevaPosicionX;
  //   this.isActivity = true;
  //   nuevaPosicionX = e.clientX;
  //   nuevaPosicionY = e.clientY;

  //   if (this.isActivity && (nuevaPosicionX !== posicionX || nuevaPosicionY !== posicionY)) {
  //     clearTimeout(this.checador);
  //     this.checador = setTimeout(() => {
  //       this.isActivity = false;
  //       this.saliendo = true;
  //       clearInterval(this.isMouseMove);
  //       clearTimeout(this.checador);
  //       this.router.navigate(['TiempoInactivo']);
  //     }, this.localTimer);
  //   }

  //   posicionX = e.clientX;
  //   posicionY = e.clientY;
  // }

  ngOnDestroy() {
    this.saliendo = true;
    clearInterval(this.isMouseMove);
    clearTimeout(this.checador);
  }

  public datosPersonales!: DatosGeneralesModel;
  public planes!: PlanModels;
  public planSeleccionado!: PlanModels;
  precioPlanSeleccionado: string = '';
  informacionSobreAccidentesPersonales: string = '';
  json: string = '';
  jsonFinal: string = '';
  mensajeAlerta: string = '';
  swAlerta: boolean = false;
  // Tiempo local de renovación 
  localTimer = environment.LOCAL_TIMER;
  // Cuanta las veces que es invocado el servicio de refrescado de token
  countRefresh = 0;
  // Verifica si hay actividad
  isActivity = false;
  // Intervalo para detectar movimiento del cursor
  isMouseMove: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private planesServices: PlanesService,
    @Inject(LOCALE_ID) public locale: string
  ) { }

  getLocalStorage(): number {
    return Number(localStorage.getItem('session_id'))
  }

  ngOnInit(): void {
    this.saliendo = false;
    this.localTimer = environment.LOCAL_TIMER;
    this.sessionId = this.getLocalStorage().toString();

    this.route.paramMap.subscribe((params: ParamMap) => {
      const resultado = params.get('infoViaje');

      if (resultado !== null) {
        this.json = resultado;
        this.jsonFinal = atob(this.json);
        this.datosPersonales = JSON.parse(this.jsonFinal);
      }
    });

    this.planesServices.getPlanes(this.sessionId.toString(),
      '00QD6000009XUSWMA4',
      'a7SD6000000XmP8MAK');
  }

  entiendo(): void {

  }
}
